module.exports = {"320507001":"元和街道","320507002":"太平街道","320507003":"黄桥街道","320507004":"北桥街道","320507005":"北河泾街道","320507006":"漕湖街道","320507100":"望亭镇","320507102":"黄埭镇","320507105":"渭塘镇","320507109":"阳澄湖镇","320507400":"开发区","320507401":"阳澄湖生态休闲旅游度假区","320507402":"苏州高铁新城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320507.json
// module id = 802
// module chunks = 0